"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateCrossrefClient = exports.ConfigDefaults = void 0;
const gen_1 = require("./gen");
__exportStar(require("./gen"), exports);
__exportStar(require("./utils"), exports);
const AGENT = 'CrossrefOpenapiClientTs/1.0';
const REPO = 'github.com/docmaps-project/crossref-openapi-client-ts';
exports.ConfigDefaults = {
    base: 'https://api.crossref.org',
    bePolite: true,
    politeMailto: 'not-provided',
    politePlatform: 'node',
};
function CreateCrossrefClient(config) {
    const c = Object.assign(Object.assign({}, exports.ConfigDefaults), config);
    const headers = {};
    if (config.bePolite) {
        headers['User-Agent'] = `${AGENT} (${REPO}; mailto:${c.politeMailto}) ${c.politePlatform}`;
    }
    return new gen_1.CrossrefClient({
        BASE: c.base,
        HEADERS: headers,
    });
}
exports.CreateCrossrefClient = CreateCrossrefClient;
//# sourceMappingURL=index.js.map